import React from 'react';
import Button from './ui/Button';
import Dialog from './ui/Dialog';

type Props = {
  open: boolean;
  title?: string;
  body?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function ConfirmModal({ open, title, body, onConfirm, onCancel }: Props) {
  return (
    <Dialog
      open={open}
      title={title ?? 'Confirmar'}
      align="start"
      onClose={onCancel}
      actions={(
        <>
          <Button variant="secondary" onClick={onCancel}>Cancelar</Button>
          <Button variant="success" onClick={onConfirm}>Confirmar</Button>
        </>
      )}
    >
      <p>{body ?? 'Tem certeza?'}</p>
    </Dialog>
  );
}
